function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UrlParams = /*#__PURE__*/function () {
  function UrlParams() {
    _classCallCheck(this, UrlParams);
    this.getParamsFromUrl();
  }
  return _createClass(UrlParams, [{
    key: "getParamsFromUrl",
    value: function getParamsFromUrl() {
      var url = window.location.toString();
      var splitUrl = url.split('?');
      if (splitUrl.length > 1) {
        var baseUrl = splitUrl[0];
        var queryString = splitUrl[1];
        var queries = queryString.split('&');
        this.analyzeParams(queries, baseUrl);
      }
    }
  }, {
    key: "analyzeParams",
    value: function analyzeParams(queries, baseUrl) {
      queries.forEach(function (query) {
        if (query === 'login_web=true') {
          history.replaceState(null, '', baseUrl);
          Shopify.analytics.publish('customer_login_success', {
            method: 'email'
          });
        } else if (query === 'register_web=true') {
          history.replaceState(null, '', baseUrl);
          Shopify.analytics.publish('customer_register_success', {
            method: 'email'
          });
        }
      });
    }
  }]);
}();
new UrlParams();